import { render, staticRenderFns } from "./PhoSingleFileUpload.vue?vue&type=template&id=346e5bc5&lang=pug"
import script from "./PhoSingleFileUpload.vue?vue&type=script&lang=js"
export * from "./PhoSingleFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports